import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Badge } from '~/ui/core/badge/Badge';
import { IconHorizontalRule } from '~/ui/core/icons';
import { Spinner } from '~/ui/core/spinner/Spinner';

import { type ThreadStatus, threadStatusLabel } from '../thread-status';

type ThreadStatusBadgeProps = {
    readonly status: ThreadStatus;
};

export const ThreadStatusBadge: FunctionComponent<ThreadStatusBadgeProps> = ({ status }) => {
    const translate = useTranslate();
    const label = threadStatusLabel(status, translate);
    if (label === undefined) return null;

    if (status === 'running') {
        return (
            <>
                <Spinner className="mr-0! text-black-900" />
                <span className="sr-only">{label}</span>
            </>
        );
    }
    if (status === 'on-hold') {
        return (
            <>
                <IconHorizontalRule
                    aria-hidden={true}
                    className="shrink-0 text-black-900"
                    data-testid="thread-status-on-hold"
                    size={12}
                />
                <span className="sr-only">{label}</span>
            </>
        );
    }

    return <Badge variant="warning">{label}</Badge>;
};
